import React from 'react';
import DetailPanelAppSheetTab from './DetailPanelAppSheetTab';

// Trade reuses the AppSheet tab implementation with the trade-specific variant
// so the drawer gets a dedicated tab without duplicating the shared UI workflow.
const DetailPanelTradeTab = (props) => <DetailPanelAppSheetTab {...props} variant="trade" />;

export default DetailPanelTradeTab;
